// extracted by mini-css-extract-plugin
module.exports = {"host-star":"styles-module__host-star___Jmqk_"};